<div class="wrapper" [ngClass]="{ animate: loading, 'in-small-container': inSmallContainer }">
	<div class="number" *ngIf="!loading">{{ number }}</div>
	<div class="title" *ngIf="!loading">{{ title }}</div>
</div>
